// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1BtoH","inputWrap":"styles_inputWrap__ZVJh7","input":"styles_input__1vjdb"};